var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8776 47.7552C37.0648 47.7552 47.7552 37.0648 47.7552 23.8776C47.7552 10.6904 37.0648 0 23.8776 0C10.6904 0 0 10.6904 0 23.8776C0 37.0648 10.6904 47.7552 23.8776 47.7552Z",
    fill: "#EF4361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2698 15.424C38.827 12.9325 38.0707 9.65487 35.5791 8.09763C33.0875 6.5404 29.8099 7.29677 28.2527 9.78835L32.3608 12.3541L31.5006 13.7185C29.3353 12.2058 26.6954 11.3159 23.8628 11.3159C21.0301 11.3159 18.405 12.2058 16.2546 13.7037L15.4092 12.3541L19.5173 9.78835C17.9453 7.29677 14.6677 6.5404 12.1761 8.09763C9.68452 9.65487 8.94298 12.9325 10.5002 15.424L14.6083 12.8583L15.4982 14.2672C12.4727 16.7143 10.5299 20.4517 10.5299 24.6488C10.5299 29.6023 13.2291 33.9329 17.2482 36.2317L15.7651 40.4733H18.405L19.458 37.2402C20.8373 37.7296 22.3204 37.9965 23.8628 37.9965C25.4348 37.9965 26.9476 37.7147 28.3417 37.2253L29.3946 40.4881H31.9307L30.5366 36.2168H30.5218C34.4964 33.9032 37.1808 29.6023 37.1808 24.6785C37.1808 20.4962 35.2528 16.7737 32.2422 14.3266L33.1468 12.888L37.2698 15.424Z",
    fill: "#FCC16A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8776 36.7358C30.5531 36.7358 35.9647 31.3243 35.9647 24.6487C35.9647 17.9732 30.5531 12.5616 23.8776 12.5616C17.2021 12.5616 11.7905 17.9732 11.7905 24.6487C11.7905 31.3243 17.2021 36.7358 23.8776 36.7358Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4263 13.5851H23.3437V16.4178H24.4263V13.5851Z",
    fill: "#808285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4263 32.6575H23.3437V35.4902H24.4263V32.6575Z",
    fill: "#808285"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8372 25.0845V24.0018H32.0046V25.0845H34.8372Z",
    fill: "#808285"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7639 25.0853V24.0027H12.9313V25.0853H15.7639Z",
    fill: "#808285"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2738 19.3542C27.1552 19.2652 26.9772 19.2949 26.8882 19.4136L24.1742 23.1806C24.0852 23.1509 23.9814 23.1213 23.8627 23.1213C23.3288 23.1213 22.8839 23.5662 22.8839 24.1001C22.8839 24.4264 23.047 24.723 23.2992 24.9009C23.2843 24.9454 23.2695 24.9899 23.2695 25.0344L22.9136 28.4603C22.8839 28.757 23.1064 29.0239 23.403 29.0536C23.6996 29.0832 23.9666 28.8608 23.9962 28.5642L24.3522 25.1382C24.3522 25.0789 24.3522 25.0048 24.3373 24.9454C24.6488 24.7823 24.8564 24.456 24.8564 24.0853C24.8564 23.848 24.7674 23.6403 24.6339 23.4624L27.3331 19.7102C27.4221 19.6064 27.4073 19.4432 27.2738 19.3542Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.38e8510595275b5f08b12bd2837a038d.svg";
export { ForwardRef as ReactComponent };